export default "__VITE_ASSET__BewcaMW$__"